import { v4 as uuid } from 'uuid';
var pingbackId = '';
var idLength = 16;
/* istanbul ignore next */
var noUUIDRandom = function () {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < idLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
var getPingbackId = function () {
    // it exists in memory
    if (!pingbackId) {
        try {
            // it exists in storage
            pingbackId = sessionStorage.getItem('giphyPingbackId');
        }
        catch (_) { }
        if (!pingbackId) {
            // we need to create it
            var hexTime = new Date().getTime().toString(16); // was told to mimic what we had
            try {
                // React Native doesn't support uuid without a polyfill
                pingbackId = "".concat(hexTime).concat(uuid().replace(/-/g, '')).substring(0, idLength); // 16 character max
            }
            catch (error) {
                /* istanbul ignore next */
                pingbackId = noUUIDRandom();
            }
            try {
                // save in storage
                sessionStorage.setItem('giphyPingbackId', pingbackId);
            }
            catch (_) { }
        }
    }
    return pingbackId;
};
export default getPingbackId;
//# sourceMappingURL=get-pingback-id.js.map